export const SET_TOKEN = 'auth/setToken'
export const SET_SHOW_TOUR = 'auth/setShowTour'
export const CLEAR_STATE = 'auth/clearState'



// WEBPACK FOOTER //
// ./src/modules/auth/store/mutations_types.js